export default {
    schwag: {
        name: 'Schwag',
        thcPct: 8,
        cbdPct: 0.1,
        needsDecarb: true,
        type: 'plant',
        category: 'General'
    },
    mids: {
        name: 'Mids',
        thcPct: 14,
        cbdPct: 0.5,
        needsDecarb: true,
        type: 'plant',
        category: 'General'
    },
    topshelf: {
        name: 'Top-Shelf',
        thcPct: 20,
        cbdPct: 1,
        needsDecarb: true,
        type: 'plant',
        category: 'General'
    },
    shakentrim: {
        name: 'Shake & Trim',
        thcPct: 8,
        cbdPct: 0.1,
        needsDecarb: true,
        type: 'plant',
        category: 'General'
    },
    hash:{       
        name: 'Hash',
        thcPct: 50,
        cbdPct: 5,
        needsDecarb: true,
        type: 'concentrate',
        category: 'General'
    },
    kief:{       
        name: 'Kief',
        thcPct: 40,
        cbdPct: 4,
        needsDecarb: true,
        type: 'concentrate',
        category: 'General'
    },
    shatter: {
        name: 'Shatter',
        thcPct: 80,
        cbdPct: 0.1,
        needsDecarb: true,
        type: 'concentrate',
        category: 'Concentrates'
    },
    bho: {
        name: 'Butane Hash Oil (BHO)',
        thcPct: 80,
        cbdPct: 0.1,
        needsDecarb: true,
        type: 'concentrate',
        category: 'Concentrates'
    },
    distilate: {
        name: 'Distilate',
        thcPct: 95,
        cbdPct: 0,
        needsDecarb: false,
        type: 'concentrate',
        category: 'Concentrates'
    },
    rso: {
        name: 'Rick Simpson Oil',
        thcPct: 73,
        cbdPct: 0.2,
        needsDecarb: false,
        type: 'concentrate',
        category: 'Concentrates'
    },
    whitewidow: {
        name: 'White Widow',
        thcPct: 18,
        cbdPct: 0.5,
        needsDecarb: true,
        type: 'plant',
        category: 'Popular Strains'
    },
    gsc: {
        name: 'Girl Scout Cookies',
        thcPct: 21,
        cbdPct: 0.5,
        needsDecarb: true,
        type: 'plant',
        category: 'Popular Strains'
    },
    chemdawg: {
        name: 'Chemdawg',
        thcPct: 22,
        cbdPct: 0.5,
        needsDecarb: true,
        type: 'plant',
        category: 'Popular Strains'
    },
    superlemonhaze: {
        name: 'Super Lemon Haze',
        thcPct: 20,
        cbdPct: 0.5,
        needsDecarb: true,
        type: 'plant',
        category: 'Popular Strains'
    },
    amnesiahaze: {
        name: 'Amnesia Haze',
        thcPct: 20,
        cbdPct: 0.5,
        needsDecarb: true,
        type: 'plant',
        category: 'Popular Strains'
    },
    bluedream: {
        name: 'Blue Dream',
        thcPct: 20,
        cbdPct: 1,
        needsDecarb: true,
        type: 'plant',
        category: 'Popular Strains'
    },
    acdc: {
        name: 'AC-DC',
        thcPct: 5,
        cbdPct: 20,
        needsDecarb: true,
        type: 'plant',
        category: 'High CBD Strains'
    },
    charlottesweb: {
        name: 'Charlotte\'s Web',
        thcPct: 1,
        cbdPct: 13,
        needsDecarb: true,
        type: 'plant',
        category: 'High CBD Strains'
    },
}